import React from 'react'

function Article(props) {
  return(
    <div>
    {React.createElement(props.lesson.article)}
    <button className="ArticleButtonBox" onClick={props.done} >Alright!</button>
    </div>
  )
}

export default Article
